import Skeleton from 'react-loading-skeleton';

const MainPageSkeleton = () => {
  return (
    <div className="search-wrapper flight-search flight-search-wr default-shadow">
      <div className="search-inner">
        <div className="results-responsive-header">
          <span className="title text-md">
            <Skeleton width={100} />
          </span>
        </div>
        <div className="flight-search-row-item">
          <div className="search-element location">
            <Skeleton height={48} />
          </div>

          <div className="search-element flight-search-rotate">
            <Skeleton height={48} />
          </div>

          <div className="search-element location">
            <Skeleton height={48} />
          </div>

          <div className="search-element date">
            <Skeleton height={48} />
          </div>
        </div>
        <div className="flight-search-row-item">
          <div className="search-element small">
            <Skeleton height={48} />
          </div>

          <div className="search-element small">
            <Skeleton height={48} />
          </div>
          <div className="search-element mode">
            <Skeleton height={48} />
          </div>
          <div className="search-element baggage">
            <Skeleton height={48} />
          </div>
          <div className="search-element baggage">
            <Skeleton height={48} />
          </div>

          <div className="search-button">
            <Skeleton height={48} width={48} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainPageSkeleton;
